export const CONTACT = {
    phoneDisplay: "73-52-52-52-37",
    phoneTel: "tel:+917352525237",
    whatsapp:
        "https://wa.me/917352525237?text=Hello%20OMSIVO%2C%20I%20am%20interested%20in%20your%20construction%20services.%20I%20would%20like%20to%20discuss%20my%20project.",
    email: "info@omsivo.in",
    maps: "https://maps.app.goo.gl/7Az4Cq7HgnDL9doJA",
    mapsFooter: "https://maps.app.goo.gl/hmUMMKovnWW9jjPNA",
    website: "www.omsivo.com",
};

export const OFFICES = [
    {
        label: "CORPORATE OFFICE",
        lines: ["OMSIVO", "Shitla Nagar, Agam Kuan", "Patna – 800007, Bihar"],
    },
    {
        label: "REGIONAL OFFICE",
        lines: ["OMSIVO", "1st Floor, Behind Madonna English School", "Khathalbari, Darbhanga – 846004, Bihar"],
    },
];

export const NAV_LINKS = [
    { label: "HOME", hash: "#home" },
    { label: "ABOUT", hash: "#about" },
    { label: "SERVICES", hash: "#services" },
    { label: "PACKAGES", hash: "#packages" },
    { label: "CONCEPTS", hash: "#concepts" },
    { label: "PROJECTS", hash: "#projects" },
    { label: "PROCESS", hash: "#process" },
    { label: "PARTNER WITH US", to: "/partner" },
    { label: "CONTACT", hash: "#contact" },
];

export const SECTORS = [
    "Residential", "Commercial", "Industrial", "Industrial Sheds", "Engineering",
    "Surveying", "Mapping", "Architecture", "Interior Design", "Turnkey Construction",
    "Project Management", "Mega Projects", "Township Development", "Building Materials",
];

const px = (id, w = 1400) =>
    `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

// Every image on the site is unique — no URL is reused across sections.
export const IMAGES = {
    heroFallback: px(9372231, 1600),   // silhouette of workers at an Indian site, sunset
    projects: px(15249523),            // B&W cranes over unfinished high-rises
    steel: px(8961134),                // engineers reviewing plans on a steel structure site
    crane: px(236709),                 // industrial warehouse interior with cranes
    highrise: px(4456656),             // Hyderabad skyline with construction cranes
    interior: px(33529500),            // luxury living room with chandelier
};

export const WHY_POINTS = [
    { icon: "FileCheck2", title: "CLEAR SCOPE", text: "Know what you are paying for." },
    { icon: "ScanEye", title: "TRANSPARENT PROCESS", text: "Clear construction stages." },
    { icon: "BadgeCheck", title: "QUALITY-FOCUSED", text: "Construction based on approved specifications." },
    { icon: "Smartphone", title: "TECHNOLOGY ENABLED", text: "Modern digital construction experience." },
    { icon: "HeartHandshake", title: "CUSTOMER FIRST", text: "Designed around customer requirements." },
    { icon: "KeyRound", title: "END-TO-END SOLUTIONS", text: "From idea to final key." },
];

export const SERVICES = [
    {
        icon: "Home", title: "RESIDENTIAL CONSTRUCTION",
        text: "Individual houses, villas, luxury homes, multi-storey residential and custom concept homes.",
        items: ["Individual House Construction", "Villas", "Luxury Homes", "Multi-Storey Residential", "Custom Concept Homes"],
    },
    {
        icon: "Building2", title: "COMMERCIAL CONSTRUCTION",
        text: "Commercial buildings, offices, retail, complexes and institutional buildings.",
        items: ["Commercial Buildings", "Offices", "Retail / Shops", "Commercial Complexes", "Institutional Buildings"],
    },
    {
        icon: "Factory", title: "INDUSTRIAL CONSTRUCTION",
        text: "Industrial buildings, sheds, warehouses, manufacturing facilities and infrastructure.",
        items: ["Industrial Buildings", "Industrial Sheds", "Warehouses", "Manufacturing Facilities", "Industrial Infrastructure"],
    },
    {
        icon: "Landmark", title: "MEGA PROJECTS & TOWNSHIP DEVELOPMENT",
        text: "Townships, large residential, commercial, mixed-use and master-planned developments.",
        items: ["Township Development", "Large Residential Development", "Mixed-Use Development", "Master-Planned Development", "Large Project Execution"],
    },
    {
        icon: "Compass", title: "ENGINEERING, SURVEY & PLANNING",
        text: "Civil & structural engineering, site survey, mapping, 2D/3D planning, BOQ and estimation.",
        items: ["Civil & Structural Engineering", "Site Survey & Mapping", "2D / 3D Planning", "BOQ & Cost Estimation", "Technical Consultation"],
    },
    {
        icon: "PenTool", title: "ARCHITECTURE & INTERIOR DESIGN",
        text: "Architectural design, elevation, space planning and turnkey interior execution.",
        items: ["Architectural Designing", "Elevation Design", "Space Planning", "Interior Design", "Turnkey Interior Solutions"],
    },
    {
        icon: "KeyRound", title: "TURNKEY & PROJECT MANAGEMENT",
        text: "Idea to handover — planning, coordination, execution and quality monitoring.",
        items: ["Turnkey Project Solutions", "Project Planning", "Site Management", "Quality Monitoring", "Vendor & Material Coordination"],
    },
    {
        icon: "Package", title: "BUILDING MATERIALS & SOLUTIONS",
        text: "Material procurement, supply, sourcing and construction material solutions.",
        items: ["Building Materials", "Material Procurement", "Material Supply", "Material Sourcing", "Marketplace — Coming Soon"],
    },
];

export const PACKAGES = [
    { name: "CLASSIC", rate: 1551, tier: "01", tag: "ENTRY / STRUCTURE-FOCUSED", bestFor: "Customers who primarily require structural construction with limited finishing scope." },
    { name: "SILVER STANDARD", rate: 1999, tier: "02", tag: "SMART STANDARD CHOICE", bestFor: "Practical residential construction with essential finishes." },
    { name: "GOLD PREMIUM", rate: 2199, tier: "03", tag: "PREMIUM VALUE", bestFor: "Customers wanting better materials and premium finishes." },
    { name: "DIAMOND LUXURY", rate: 2499, tier: "04", tag: "LUXURY LIVING", bestFor: "Upgraded finishes, designer elements and enhanced specifications." },
    { name: "PLATINUM ROYAL", rate: 2999, tier: "05", tag: "SIGNATURE LUXURY", bestFor: "Premium luxury finishes, upgraded specifications and customization." },
];

export const COMPARISON = [
    {
        category: "STRUCTURE & CIVIL",
        rows: [
            { spec: "Excavation & PCC", values: ["Included", "Included", "Included", "Included", "Included"] },
            { spec: "RCC Structure", values: ["Included", "Included", "Included", "Included", "Included"] },
            { spec: "Masonry", values: ["Standard Brickwork", "Quality Brickwork", "Premium Brickwork", "Premium Masonry", "Premium Precision Masonry"] },
            { spec: "Plaster — Internal / External", values: ["Standard", "Smooth Finish", "Premium Smooth Finish", "Luxury Smooth Finish", "Premium Luxury Finish"] },
            { spec: "Waterproofing", values: ["Not Included", "Critical Areas Only", "Standard", "Enhanced", "Advanced System"] },
        ],
    },
    {
        category: "FLOORING",
        rows: [
            { spec: "Living / Dining / Bedrooms", values: ["Structure Only", "Verified Tiles (Up to 2'×2')", "Premium Verified Tiles (2'×2')", "Large Format Premium Tiles", "Luxury / Imported Tiles"] },
            { spec: "Kitchen Flooring", values: ["Structure Only", "Anti-skid Tiles", "Premium Tiles", "Premium Verified", "Luxury Anti-skid Tiles"] },
            { spec: "Bathroom Flooring", values: ["Structure Only", "Anti-skid Tiles", "Premium Tiles", "Premium Matt Tiles", "Luxury Designer Tiles"] },
            { spec: "Staircase Finish", values: ["RCC Only", "Kota / Granite Option", "Premium Granite", "Designer Granite", "Luxury Stone Finish"] },
            { spec: "Skirting & Window Sill", values: ["Not Included", "Standard", "Premium", "Granite / Premium", "Luxury Stone"] },
        ],
    },
    {
        category: "KITCHEN",
        rows: [
            { spec: "Kitchen Platform", values: ["Structure Only", "Granite Platform", "Premium Granite", "Premium Granite (Edge Finish)", "Quartz / Imported Stone"] },
            { spec: "Sink & Mixer", values: ["Not Included", "SS Sink + Std. Mixer", "Premium SS Sink + Mixer", "Premium Deep Sink + Mixer", "Luxury Sink + Mixer"] },
            { spec: "Dado Tiles — Wall", values: ["Not Included", "Tiles Up to 2 ft.", "Tiles Up to 2 ft. (Premium)", "Full Height Tiles (Designer)", "Full Height Luxury Finish"] },
            { spec: "Modular Kitchen", values: ["On Request", "On Request", "Provision", "Standard Modular", "Premium Modular (Soft Close)"] },
        ],
    },
    {
        category: "BATHROOM",
        rows: [
            { spec: "Wall Tiles", values: ["Not Included", "Tiles Up to 7 ft.", "Premium Tiles", "Full Height Tiles (Designer)", "Luxury Designer Tiles"] },
            { spec: "Sanitary Fittings", values: ["Not Included", "Standard", "Premium", "Premium / Jaquar Equivalent", "Luxury Collection"] },
            { spec: "CP Fittings", values: ["Not Included", "Standard", "Premium", "Premium / Jaquar Equivalent", "Luxury Collection"] },
            { spec: "Shower", values: ["Not Included", "Standard", "Premium", "Rain Shower", "Luxury Rain Shower"] },
            { spec: "Waterproofing", values: ["Not Included", "Standard", "Enhanced", "Premium System", "Advanced Multi-layer System"] },
        ],
    },
    {
        category: "DOORS & WINDOWS",
        rows: [
            { spec: "Main Door", values: ["Not Included", "Decorative Flush Door", "Veneer Finish Door", "Designer Veneer Door", "Premium Designer Entrance Door"] },
            { spec: "Internal Doors", values: ["Not Included", "Flush Door", "Premium Flush Door", "Designer Flush Door", "Designer Veneer Door"] },
            { spec: "Windows", values: ["Not Included", "Aluminium Windows", "Premium uPVC / Aluminium", "Premium uPVC with Toughened Glass", "Luxury High Performance Windows"] },
            { spec: "Window Glass", values: ["Not Included", "Clear Glass", "Clear Float Glass", "Toughened Glass (Selected Areas)", "Toughened / Laminated Glass"] },
            { spec: "Railings — Staircase / Balcony", values: ["On Request", "MS Railing", "SS Railing", "SS + Glass Railing", "Frameless Glass Railing"] },
        ],
    },
];

export const CONCEPTS = [
    { icon: "Thermometer", title: "Heat-Insulated Homes", text: "Envelope designed to reduce heat gain and keep interiors comfortable." },
    { icon: "Sun", title: "Cool Roof Homes", text: "Roof systems planned to reflect heat and lower indoor temperatures." },
    { icon: "CloudRainWind", title: "Climate-Ready Homes", text: "Homes planned around local climate, orientation and seasonal behaviour." },
    { icon: "Zap", title: "Energy-Efficient Homes", text: "Design and systems that reduce everyday energy consumption." },
    { icon: "Cpu", title: "Smart Homes", text: "Automation-ready planning for lighting, security and controls." },
    { icon: "SunMedium", title: "Solar-Ready Homes", text: "Structure and electrical planning prepared for solar integration." },
    { icon: "Wind", title: "Natural Ventilation Homes", text: "Layouts that move air naturally through the living spaces." },
    { icon: "Droplets", title: "Rainwater Harvesting Homes", text: "Collection and recharge planning built into the design." },
    { icon: "ShieldCheck", title: "Earthquake-Resistant Construction", text: "Structural design aligned with seismic safety considerations." },
    { icon: "Waves", title: "Flood-Resistant Construction", text: "Plinth, drainage and material strategies for flood-prone sites." },
    { icon: "Accessibility", title: "Senior-Friendly Homes", text: "Step-free access, safer bathrooms and easier movement planning." },
    { icon: "Sparkles", title: "Future-Ready Homes", text: "Provision for expansion, upgrades and evolving family needs." },
    { icon: "Leaf", title: "Sustainable Homes", text: "Resource-conscious design, materials and construction practices." },
    { icon: "Gem", title: "Luxury Villa Concepts", text: "Premium villa concepts with elevated design and finish direction." },
    { icon: "DraftingCompass", title: "Custom Concept Homes", text: "A home designed entirely around your life and your site." },
];

export const BUILD_STAGES = [
    { key: "SITE", text: "Every structure begins with understanding the land." },
    { key: "FOUNDATION", text: "The load path is established below ground." },
    { key: "STRUCTURE", text: "The RCC frame rises — columns, beams and slabs." },
    { key: "MASONRY", text: "Walls assemble and spaces take shape." },
    { key: "ELECTRICAL", text: "Concealed wiring routes through the structure." },
    { key: "PLUMBING", text: "Water and drainage lines are laid with precision." },
    { key: "FLOORING", text: "Surfaces are finished level by level." },
    { key: "FINISHING", text: "Plaster, paint, fittings and detail work complete." },
    { key: "FINAL BUILDING", text: "From your first idea to your final key." },
];

export const EXPLODED_LAYERS = [
    { key: "SITE", text: "The plot, its orientation, levels and soil context.", relevance: "Every decision begins with the site — survey, measurement and planning start here." },
    { key: "FOUNDATION", text: "Footings and base structure that transfer load to the ground.", relevance: "The foundation carries the entire building — its design defines safety and lifespan." },
    { key: "STRUCTURE", text: "RCC columns, beams and slabs forming the skeleton.", relevance: "The structural frame determines strength, span and flexibility of spaces." },
    { key: "MASONRY", text: "Wall construction that encloses and divides spaces.", relevance: "Masonry defines rooms, privacy, openings and the building envelope." },
    { key: "ELECTRICAL", text: "Concealed wiring, circuits, points and distribution.", relevance: "Planned electrical routing keeps homes safe, maintainable and upgrade-ready." },
    { key: "PLUMBING", text: "Water supply, drainage and sanitary lines.", relevance: "Correct plumbing design prevents leakage, dampness and future repair costs." },
    { key: "FLOORING", text: "Floor finishes across every level of the building.", relevance: "Flooring defines daily comfort, durability and the feel of every space." },
    { key: "FINISHING", text: "Plaster, paint, joinery, fittings and fixtures.", relevance: "Finishing is what you see and touch every day — quality lives here." },
    { key: "ROOF", text: "Roof slab, waterproofing and weather protection.", relevance: "The roof protects everything below it — thermal and water performance matter." },
];

export const PROCESS_STEPS = [
    { n: "01", title: "REQUIREMENT", text: "We begin by understanding what you want to build, where, and why." },
    { n: "02", title: "CONSULTATION", text: "A detailed discussion with our team on scope, direction and possibilities." },
    { n: "03", title: "SITE VISIT", text: "Our team visits your site to understand ground conditions and context." },
    { n: "04", title: "SURVEY", text: "Measurement, mapping and documentation of the plot and its levels." },
    { n: "05", title: "DESIGN", text: "Architectural planning, 2D/3D design and concept development." },
    { n: "06", title: "ESTIMATION", text: "Detailed BOQ and cost estimation — powered by the OMSIVO Customer App." },
    { n: "07", title: "SCOPE FINALIZATION", text: "Specifications, inclusions and exclusions are defined in writing." },
    { n: "08", title: "AGREEMENT", text: "A clear agreement covering scope, stages and responsibilities." },
    { n: "09", title: "CONSTRUCTION", text: "Execution begins — stage by stage, with monitored progress." },
    { n: "10", title: "QUALITY CHECKS", text: "Stage-wise quality monitoring against approved specifications." },
    { n: "11", title: "HANDOVER", text: "Final checks, documentation and the handover of your keys." },
];

export const TURNKEY_STEPS = ["IDEA", "DESIGN", "ENGINEERING", "ESTIMATION", "PROCUREMENT", "CONSTRUCTION", "INTERIOR", "HANDOVER"];

export const JOURNEY_STEPS = [
    { key: "DISCOVER", icon: "Search" },
    { key: "DESIGN", icon: "PenTool" },
    { key: "ESTIMATE", icon: "Calculator", app: true },
    { key: "BOOK", icon: "CalendarCheck" },
    { key: "BUY", icon: "ShoppingCart" },
    { key: "BUILD", icon: "HardHat" },
    { key: "TRACK", icon: "Radar" },
    { key: "PAY", icon: "Wallet" },
    { key: "HANDOVER", icon: "KeyRound" },
    { key: "MAINTAIN", icon: "Wrench" },
];

export const APP_FEATURES = [
    "Cost Estimation", "Package Comparison", "Engineer Discussion", "Live Site Engineer Consultation",
    "Design & Planning", "Project Tracking", "BOQ", "Quotations", "Payments", "Documents",
    "Building Material Purchase", "Material Tracking", "Customer Support", "Maintenance",
];

export const FAQS = [
    { q: "How does OMSIVO construction work?", a: "OMSIVO follows an 11-stage process: requirement, consultation, site visit, survey, design, estimation, scope finalization, agreement, construction, quality checks and handover. Every stage is defined and communicated before work begins." },
    { q: "What are OMSIVO construction packages?", a: "OMSIVO offers five construction packages: Classic, Silver Standard, Gold Premium, Diamond Luxury and Platinum Royal. Each package is priced per square foot with a defined scope of specifications." },
    { q: "What are the current package rates?", a: "Classic ₹1,551/Sq.Ft., Silver Standard ₹1,999/Sq.Ft., Gold Premium ₹2,199/Sq.Ft., Diamond Luxury ₹2,499/Sq.Ft. and Platinum Royal ₹2,999/Sq.Ft." },
    { q: "What is included in each package?", a: "Each package defines confirmed specifications across structure & civil, flooring, kitchen, bathroom and doors & windows — published side by side in the package comparison table on this website. Detailed inclusions, exclusions and optional items are shared in writing during consultation." },
    { q: "Can OMSIVO build residential projects?", a: "Yes. OMSIVO builds individual houses, villas, luxury homes, multi-storey residential projects and custom concept homes." },
    { q: "Can OMSIVO undertake commercial construction?", a: "Yes. OMSIVO constructs commercial buildings, offices, retail spaces, commercial complexes and institutional buildings." },
    { q: "Can OMSIVO undertake industrial projects?", a: "Yes. OMSIVO delivers industrial buildings, industrial construction, warehouses, manufacturing facilities and industrial infrastructure." },
    { q: "Does OMSIVO build industrial sheds?", a: "Yes. Industrial shed design and construction is a confirmed OMSIVO service." },
    { q: "Does OMSIVO provide civil and structural engineering?", a: "Yes. OMSIVO provides civil engineering, structural engineering, structural design, site engineering, construction planning and technical consultation." },
    { q: "Does OMSIVO provide surveying and mapping?", a: "Yes. Site survey, land measurement, surveying, mapping, 2D/3D planning, layout planning and master planning are part of OMSIVO services." },
    { q: "Does OMSIVO provide architectural design?", a: "Yes. Architectural designing, building planning, 2D/3D design, elevation design, space planning and concept development are offered." },
    { q: "Does OMSIVO provide interior design?", a: "Yes. Residential, commercial, office and retail interior design with material selection and turnkey interior execution." },
    { q: "Does OMSIVO undertake township development?", a: "Yes. Township development, large residential development, mixed-use and master-planned development are part of OMSIVO's large-scale development services." },
    { q: "Does OMSIVO handle turnkey construction?", a: "Yes. OMSIVO delivers complete turnkey projects — idea, design, engineering, estimation, procurement, construction, interior and handover — with one partner across the entire journey." },
    { q: "How can I request a site visit?", a: "Use the REQUEST SITE VISIT form on this website, call 73-52-52-52-37, or message us on WhatsApp. Our team will schedule the visit with you." },
    { q: "How can I contact OMSIVO?", a: "Call 73-52-52-52-37, email info@omsivo.in, chat on WhatsApp, or visit our offices in Patna (Shitla Nagar, Agam Kuan) and Darbhanga (Khathalbari)." },
    { q: "How can I get project cost estimation?", a: "Detailed project cost estimation will be provided through the OMSIVO Customer App. You can also request a free estimate through the website and our team will assist you." },
    { q: "When will the OMSIVO App launch?", a: "The OMSIVO Customer App is currently marked COMING SOON. The launch timeline will be announced by OMSIVO." },
];

export const PROJECT_FILTERS = ["Residential", "Commercial", "Industrial", "Industrial Shed", "Mega Projects", "Interior"];

export const SHOWCASES = {
    engineering: {
        kicker: "ENGINEERING",
        title: ["ENGINEERING BEHIND", "EVERY STRUCTURE."],
        items: ["Civil Engineering", "Structural Engineering", "Site Survey", "Mapping", "Structural Design", "BOQ", "Estimation", "Technical Consultation", "Construction Planning"],
        cta: "TALK TO OUR TEAM",
        image: "steel",
    },
    industrial: {
        kicker: "INDUSTRIAL",
        title: ["FROM HOMES TO", "INDUSTRIAL PROJECTS."],
        items: ["Industrial Buildings", "Industrial Sheds", "Warehouses", "Manufacturing Facilities"],
        cta: "DISCUSS YOUR INDUSTRIAL PROJECT",
        image: "crane",
    },
    mega: {
        kicker: "MEGA PROJECTS & TOWNSHIP DEVELOPMENT",
        title: ["FROM INDIVIDUAL PROJECTS", "TO MEGA DEVELOPMENTS."],
        headline2: "BUILT FOR SCALE.",
        items: ["Township Development", "Large Residential Development", "Commercial Development", "Mixed-Use Development", "Master Planning", "Large-Scale Development"],
        cta: "DISCUSS A DEVELOPMENT",
        image: "highrise",
    },
    interior: {
        kicker: "ARCHITECTURE & INTERIOR",
        title: ["DESIGN THE SPACE.", "BUILD THE EXPERIENCE."],
        items: ["Residential Interior", "Luxury Interior", "Office Interior", "Commercial Interior", "Retail Interior", "Space Planning", "Material Selection", "Turnkey Interior"],
        cta: "PLAN YOUR INTERIOR",
        image: "interior",
    },
};

// Dark, cinematic night-construction footage (Pexels 36620693 — verified renditions).
export const HERO_VIDEO = {
    src: "https://videos.pexels.com/video-files/36620693/15526542_1280_720_30fps.mp4",
    srcMobile: "https://videos.pexels.com/video-files/36620693/15526540_640_360_30fps.mp4",
    poster: "https://images.pexels.com/videos/36620693/pexels-photo-36620693.jpeg?auto=compress&cs=tinysrgb&w=1600",
};

export const WHAT_BUILDING = [
    { slug: "residential", icon: "Home", title: "Residential", text: "Homes, villas and multi-storey residential projects." },
    { slug: "commercial", icon: "Building2", title: "Commercial", text: "Offices, retail, complexes and institutional buildings." },
    { slug: "industrial", icon: "Factory", title: "Industrial", text: "Industrial buildings, warehouses and facilities." },
    { slug: "industrial-sheds", icon: "Warehouse", title: "Industrial Sheds", text: "Steel and pre-engineered shed structures." },
    { slug: "mega-projects", icon: "Landmark", title: "Mega Projects", text: "Large-scale and mixed-use developments." },
    { slug: "township-development", icon: "Map", title: "Township Development", text: "Master-planned townships and phased development." },
];

export const JOURNEY_FULL = [
    { key: "IDEA" }, { key: "SITE" }, { key: "SURVEY" }, { key: "DESIGN" }, { key: "ENGINEERING" },
    { key: "ESTIMATION", app: true }, { key: "FOUNDATION" }, { key: "STRUCTURE" }, { key: "CONSTRUCTION" },
    { key: "FINISHING" }, { key: "FINAL KEY" },
];

export const GALLERY_ITEMS = [
    { slug: "residential", title: "Residential", img: px(30580640), tags: ["STRUCTURE", "DESIGN", "INTERIOR"] },
    { slug: "commercial", title: "Commercial", img: px(11442140), tags: ["ENGINEERING", "DESIGN", "MATERIAL"] },
    { slug: "industrial", title: "Industrial", img: px(34550841), tags: ["STRUCTURE", "ENGINEERING"] },
    { slug: "industrial-sheds", title: "Industrial Sheds", img: px(12951624), tags: ["STRUCTURE", "MATERIAL"] },
    { slug: "architecture", title: "Architecture", img: px(32666364), tags: ["DESIGN"] },
    { slug: "engineering", title: "Engineering", img: px(8961146), tags: ["ENGINEERING", "STRUCTURE"] },
    { slug: "interior-design", title: "Interiors", img: px(13722826), tags: ["INTERIOR", "MATERIAL", "DESIGN"] },
    { slug: "mega-projects", title: "Mega Projects", img: px(31713110), tags: ["ENGINEERING", "DESIGN"] },
    { slug: "township-development", title: "Township Development", img: px(34480710), tags: ["DESIGN", "ENGINEERING"] },
];

export const SECTOR_ROUTES = {
    "Residential": "residential", "Commercial": "commercial", "Industrial": "industrial",
    "Industrial Sheds": "industrial-sheds", "Engineering": "engineering", "Surveying": "surveying",
    "Mapping": "mapping", "Architecture": "architecture", "Interior Design": "interior-design",
    "Turnkey Construction": "turnkey-construction", "Project Management": "project-management",
    "Mega Projects": "mega-projects", "Township Development": "township-development", "Building Materials": "building-materials",
};
